import { render, staticRenderFns } from "./promanagement.vue?vue&type=template&id=0b98af90&scoped=true&"
import script from "./promanagement.vue?vue&type=script&lang=js&"
export * from "./promanagement.vue?vue&type=script&lang=js&"
import style0 from "./promanagement.vue?vue&type=style&index=0&id=0b98af90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98af90",
  null
  
)

export default component.exports